export const processPriceString = (price: string | number): number =>
  parseInt(`${price}`.replace('$', '').replace(',', ''), 10);

export const processPriceGst = (price: number | string) => processPriceString(price) / 11;

export const processKilometers = (kilometers: string): number =>
  parseInt(`${kilometers}`.replace(' km', '').replace(',', ''), 10);
